import { AuthActions } from "../LoginRedux/Action";
import { scannerActions } from "./Action";

const initialState = {
  scannedBoxIDOrderDetailsSuccess: null,
  scannedBoxIDOrderError: null,
  scannedOrderIDOrderDetailsSuccess: null,
  scannedOrderIDOrderError: null,
};

export const scannerReducer = (state = initialState, action) => {
  switch (action.type) {
    case scannerActions.FETCH_BOX_SCAN_ORDER_DATA_SUCCESS:
      return {
        ...state,
        scannedBoxIDOrderDetailsSuccess: action.payload,
        scannedBoxIDOrderError: null,
      };

    case scannerActions.FETCH_BOX_SCAN_ORDER_DATA_FAILURE:
      return {
        ...state,
        scannedBoxIDOrderDetailsSuccess: null,
        scannedBoxIDOrderError: action.payload,
      };

    case scannerActions.FETCH_ORDER_SCAN_ORDER_DATA_SUCCESS:
      return {
        ...state,
        scannedOrderIDOrderDetailsSuccess: action.payload,
        scannedOrderIDOrderError: null,
      };

    case scannerActions.FETCH_ORDER_SCAN_ORDER_DATA_FAILURE:
      return {
        ...state,
        scannedOrderIDOrderDetailsSuccess: null,
        scannedOrderIDOrderError: action.payload,
      };

    default:
      return state;
  }
};
